import { createStyles } from "@material-ui/core";

const eventNameCard = () => createStyles({
    content: {
        padding: '0 20px 17px',
    },
});

export default eventNameCard;
